// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__ezwND","range":"MonthRangeSwitch_range__119Td","disabled":"MonthRangeSwitch_disabled__1xtJg"};